/* eslint-disable react/jsx-props-no-spreading */
// use ...props for routing
import React from "react";
import { Layout } from "antd";
import { useParams } from "react-router-dom";

// Components
import MyProgress from "common/my_progress";
import ChapterList from "./ChapterList";

// Styles
import styles from "./MyLevel.module.css";

function MyLevel() {
  const params = useParams();

  return (
    <Layout.Content className="content-container">
      {/* TODO: revert background color of MyProgress */}
      <MyProgress
        defaultLevelId={Number(params.levelId || 0)}
        showViewDetailButton={false}
      />
      <Layout.Content className={styles.contentContainer}>
        <ChapterList params={params} />
      </Layout.Content>
    </Layout.Content>
  );
}

export default MyLevel;
